// axios
import axios from 'axios'

// const domain = "http://127.0.0.1:8000/"
// const domain = "https://examapi.heyway.com"
// const domain = "http://exambackend.citiguide.dk"
// const domain = "https://simplydriving-exam-backend.citiguide.dk/"
// const domain = "https://motor.simplyteori.dk/simplydriving-exam-backend/public/"
const domain = "https://exambackendtest.simplyteori.dk/simplydriving-exam-backend/public/"

export default axios.create({
	baseURL : domain
})
